// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IStringSegment {
	buffer: string | undefined;

	offset: number;

	length: number;

	value: string | undefined;

	hasValue: boolean;

	$type?: string | undefined;
}
export class StringSegment {
	constructor(data?: IStringSegment) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	buffer: string | undefined;

	offset: number = 0;

	length: number = 0;

	value: string | undefined;

	hasValue: boolean = false;

	static $type: string = "Microsoft.Extensions.Primitives.StringSegment, ";
	$type?: string | undefined = StringSegment.$type;
}

